import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import numeral from 'numeral';
import Highcharts from 'highcharts';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import HighchartsReact from 'highcharts-react-official';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// Components
// import GroupCard from '../../components/GroupCard';

// Actions
import { gameActions } from '../../actions';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';
// import infoModal from '../../assets/info-modal-1.png';

NoDataToDisplay(Highcharts);

// INLINE COMPONENTS
const AccuracyCompletedChart = ({ data }) => {
  const minBars = data?.length < 12 ? 12 : data?.length; // Minimum height based on number of groups

  const chartOptions = {
    chart: {
      type: 'bar', // Changed from 'column' to 'bar' for horizontal bars
      height: 35 * minBars,
      // height: 'auto', // Allow auto height
      backgroundColor: 'transparent',
      inverted: true, // This makes it horizontal
    },
    credits: {
      enabled: false,
    },
    title: {
      // text: 'Accuracy of Completed Loan Applications by Group',
      text: '',
    },
    xAxis: {
      title: {
        text: 'Groups',
      },
      categories: data.map((group) => group.groupName),
    },
    yAxis: {
      title: {
        text: 'Completed Loans: Top 20 Teams',
      },
      allowDecimals: false,
      stackLabels: {
        enabled: true,
        formatter: function () {
          return Highcharts.numberFormat(this.total, 0); // Format the total value
        },
        x: 10,
      },
    },
    legend: {
      enabled: true,
      align: 'center',
    },
    tooltip: {
      headerFormat: '<span style="font-size:12px">{point.key}</span><br/>',
      pointFormat:
        '<span style="color:{series.color}">{series.name}: </span>' +
        '<b>{point.y}</b><br/>',
      shared: false,
    },
    plotOptions: {
      bar: {
        stacking: 'normal',
        pointWidth: 25,
        dataLabels: {
          enabled: true,
        },
      },
      series: {
        enableMouseTracking: false,
      },
    },
    series: [
      {
        name: 'Completed',
        data: data.map((group) => group.incorrectDecisions),
        color: '#95b9ec',
        dataLabels: {
          enabled: false,
        },
      },
      {
        name: 'Correct',
        data: data.map((group) => group.correctDecisions),
        color: '#559d65',
        dataLabels: {
          enabled: true,
          //   Display the % of accuracy instead of the number
          formatter: function () {
            // Round the percentage
            return `${Math.round(this?.percentage)}%`;
          },
        },
      },
    ],
    noData: {
      style: {
        fontSize: '16px',
        color: '#666',
      },
      position: {
        align: 'center',
        verticalAlign: 'middle',
      },
    },
  };

  return (
    <div className='accuracy-completed-chart'>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        containerProps={{ style: { height: 'auto', width: '100%' } }}
      />
    </div>
  );
};

class DebriefAccuracyCompleted extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item || null,
    };
  }

  componentDidMount() {
    const { dispatch, match, game } = this.props;
    if (match.params.id && !game?.data?._id) {
      dispatch(gameActions.fetchGames(match.params.id));
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      item: newProps.item,
    });
  }

  render() {
    const { game } = this.props;
    const gameData = game.data;

    // Calculate accuracy data for each group
    const accuracyCompletedData = [];

    gameData?.groups?.forEach((group, groupIndex) => {
      const groupIdentifier = group?.name || `Team ${groupIndex + 1}`;

      // Step 1: Get all decision items for this group (completed loan applications)
      const decisionItems =
        group?.items?.filter((item) => item.activity === 'decision') || [];

      // Step 2: Count correct decisions (performance = 100)
      const correctDecisions = decisionItems.filter(
        (item) => item.performance === 100
      ).length;

      // Step 3: Calculate totals and accuracy
      const totalDecisions = decisionItems.length;
      const incorrectDecisions = totalDecisions - correctDecisions;
      const accuracy =
        totalDecisions > 0 ? (correctDecisions / totalDecisions) * 100 : 0;

      // Only include groups that have decisions
      if (totalDecisions > 0) {
        accuracyCompletedData.push({
          groupName: groupIdentifier,
          groupId: group._id,
          totalDecisions,
          correctDecisions,
          incorrectDecisions,
          accuracy,
        });
      }
    });

    // Sort by totalDecisions descending
    accuracyCompletedData.sort((a, b) => {
      return b.totalDecisions - a.totalDecisions;
    });

    // Calculate overall statistics
    const overallStats = {
      totalGroups: accuracyCompletedData.length,
      totalDecisions: accuracyCompletedData.reduce(
        (sum, group) => sum + group.totalDecisions,
        0
      ),
      totalCorrect: accuracyCompletedData.reduce(
        (sum, group) => sum + group.correctDecisions,
        0
      ),
      averageAccuracy:
        accuracyCompletedData.length > 0
          ? accuracyCompletedData.reduce(
              (sum, group) => sum + group.accuracy,
              0
            ) / accuracyCompletedData.length
          : 0,
    };

    overallStats.overallAccuracy =
      overallStats.totalDecisions > 0
        ? (overallStats.totalCorrect / overallStats.totalDecisions) * 100
        : 0;

    return (
      <div>
        <Header />

        {/* <h2 className='mt-3 sec-title fs-3'>
          Accuracy Completed{' '}
          <small className='float-end'>
            <DebriefMenu
              game_id={game.data._id}
              location={this.props.location}
            />
          </small>
        </h2> */}

        <h2 className='d-flex mt-3 sec-title fs-3'>
          <span className='d-none d-xl-inline text-nowrap'>
            Accuracy Completed
          </span>
          {/* Display sub-menu on larger viewports */}
          <DebriefMenu
            className='small d-flex justify-content-between justify-content-xl-end align-items-center ms-xl-auto w-100'
            game_id={game.data._id}
            location={this.props.location}
          />
        </h2>

        <div className='row mt-3'>
          <div className='col-12 mb-3'>
            <p className='text-center'>
              This chart shows the accuracy performance for completed loan
              applications by each group using horizontal bars.
            </p>
          </div>

          {/* CHART */}
          <div className='col-12'>
            <div className='mb-4 pt-3 shadow bg-white border'>
              <AccuracyCompletedChart
                data={accuracyCompletedData.slice(0, 20)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { player, game } = state;
  return {
    game,
    player,
  };
}

export default connect(mapStateToProps)(DebriefAccuracyCompleted);
